const RENEW_TOKEN = "✔️ Renew token with updated 'exp' field.",
	SET_TOKEN = '✔️ Set token.',
	START_LOADING_CONTENT = '✔️ Started loading content.',
	FINISHED_LOADING_CONTENT = '✔️ Finished loading content.';

export {
	RENEW_TOKEN,
	SET_TOKEN,
	START_LOADING_CONTENT,
	FINISHED_LOADING_CONTENT
};

export default {
	[SET_TOKEN](state, { token }) {
		state.token = token;
	},
	[RENEW_TOKEN](state, { token }) {
		state.token = token;
	},
	[START_LOADING_CONTENT](state) {
		state.loadingContent = true;
	},
	[FINISHED_LOADING_CONTENT](state) {
		state.loadingContent = false;
	}
};
